import React from 'react'
import TextField from '../../../fields/TextField'
import SelectField from '../../../fields/SelectField'
import ProfilePicture from '../../../ProfilePicture'
import { buildOptions, sponsorOptions } from '../../../utils'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from 'react-bootstrap'
import DateField from "../../../fields/DateField"
import AgeField from "../../../fields/AgeField"
import { updateMentors } from '../../../actions'

export const General = ({ confirmDelete }) => {
  const dispatch = useDispatch()
  const { mentors, org_dependant_data, organization, resident } = useSelector(state=>state)
  const { category_options } = org_dependant_data
  const [ referrals, setReferrals ] = React.useState(org_dependant_data.referrals)

  const fetchReferrals = (filter_name="") => {
    return $.ajax({
      url: `/organizations/${organization.name}/referrals.json?q[first_name_or_last_name_or_contact_org_cont]=${filter_name}&referral_id_to_include=${resident.referral_id}`
    }).then((payload) => setReferrals(payload))
  }

  function formatReferralOptions() {
    const referralOptions = referrals.map((referral) => ({
      value: referral.id,
      label: `${referral.first_name || ""} ${referral.last_name || ""} ${
        referral.contact_org ? `(${referral.contact_org})` : ""
      }`
    }))
    referralOptions.push({
      value: 'add',
      label: 'Add new referral source'
    });
    return referralOptions
  }


  const mentorOptions = mentors.map((mentor) => ({
    value: mentor.id,
    label: `${mentor.first_name} ${mentor.last_name}`
  }))


  const statusOptions = buildOptions(category_options);


  return (
    <div className="p-4">
      <ProfilePicture/>
      <TextField name="first_name" label="First Name" action="edit" col="none"/>
      <TextField name="middle_name" label="Middle Name" action="edit" col="none"/>
      <TextField name="last_name" label="Last Name" action="edit" col="none"/>
      <TextField name="nickname" label="Nickname/Preferred name" action="edit" col="none"/>
      <TextField name="email" label="Email" action="edit" col="none" trim/>
      <TextField name="phone" label="Phone" action="edit" col="none"/>
      <DateField name="birthdate" label="Birthdate" action="edit" col="none" />
      <AgeField />
      <TextField name="mailing_address" label="Mailing Address" action="edit" col="none"/>
      <SelectField name="mentor_ids" label="Mentors" options={mentorOptions} onChange={(options)=>dispatch(updateMentors(options))}  action="edit" col="none" isMulti/>
      <SelectField name="category_list" label="Category" options={statusOptions} creatable action="edit" col="none" isMulti />
      <TextField name="level" label="Level/Phase/Tier" action="edit" col="none"/>
      <TextField name="client_number" label="Client Number" action="edit" col="none"/>
      <SelectField
        name="referral_id"
        label="Referral Source"
        options={formatReferralOptions()}
        action="edit"
        col="none"
        onMenuOpen={()=>fetchReferrals()}
        loadOptions={(inputValue, callback) => {
            fetchReferrals(inputValue)
            .then(() => callback(formatReferralOptions()));
        }}
        placeholder="Type to search..."
      />
      <SelectField name="sponsor" label="Sponsor" action="edit" col="none"options={sponsorOptions} />
      <TextField name="occupation" label="Occupation" action="edit" col="none"/>
      <TextField name="address" label="Address" action="edit" col="none"/>
      <TextField name="city" label="City" action="edit" col="none"/>
      <TextField name="state" label="State" action="edit" col="none"/>
      <TextField name="zip" label="Zip" action="edit" col="none"/>
      <TextField name="criminal_arrest_history" label="Criminal/Arrest History" action="edit" as="textarea" col="none"/>
      <div className="pt-4">
        <Button
          variant="outline-danger w-100"
          onClick={confirmDelete}>
          Delete Client Profile
        </Button>
      </div>
    </div>
  )
}
